module.exports = __webpack_public_path__ + "static/submit-fail.2efc1b0a.png";